export type Directions = 'top' | 'bottom' | 'right' | 'left';

export const DIRECTIONS: { [key in Directions]: Directions } = {
  top: 'top',
  bottom: 'bottom',
  right: 'right',
  left: 'left',
};
